module.exports = __webpack_public_path__ + "img/feature-5.6d24b10.png";